export const IS_ACTIVE_WORKER = "isActiveWorker";
export const EMPTY = "";
export const INCORRECT_ENTRY = "Incorrect entry.";
export const ALREADY_EXISTS = "Already exists.";
export const REQUIRED = "Field Required";
export const EMAIL = "email";
export const EMPLOYEE_ID = "employeeId";
export const MAIL_FORMAT_RE = /^\w+\S*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/;
export const NAME_RE = /^[A-Za-z]+$/;
export const NUMBER_RE = /^[0-9]+$/;
export const PENDING = "pending";
export const ADD = "add";
export const EDIT = "edit";
export const ERROR_WHILE_SAVE = " An error occurred while saving data. Please try again.";
export const BILLRATE_REQUIRES = "Bill rate must be greater than 0."
export const SERVICE_COS = {'function':"Service COS", 'id':"02100"};
export const OPERATIONAL_DISTRICT_BUILDING = {'District':["A-COLLEGEVILLE"], 'Building':["A 01"]};
export const OPERATIONS = "OPS";